import CityPageTemplate from "../city-template/CityPageTemplate";
import { fontanaConfig } from "./data";

export default function FontanaPage() {
  return <CityPageTemplate config={fontanaConfig} />;
}